function customMuralState() {
  return {
    width: [{ inch: "", feet: "", cm: "" }],
    height: { inch: "", feet: "", cm: "" },

    flipped: false,
    cropboxData: {},

    formStep: 1,
    dimention: "feetInches",

    newImage: undefined,
    newImageURL: undefined,
    croppedImageURL: null,

    variant: undefined,
    approved: false,
    imageUsagePermission: false,
    quantity: 1,
    instructions: "",

    _cropBoxInitialized: false,

    gotoFormStep(step) {
      if (!this.variant) {
        alert("Please select a paper type.");
        return;
      }

      if (!this.newImage) {
        alert("Please upload your image.");
        return;
      }

      if (Number(this.calculatePrice()) <= 0) {
        alert("Please enter your wall height and width.");
        return;
      }

      this.formStep = step;
    },

    handleDimentionChange(event) {
      const dimention = event.target.value;
      const name = event.target.name;
      const type = event.target.dataset.type;

      if (name === "height") this.height[type] = dimention;
      if (name === "width") this.width[0][type] = dimention;

      if (type === "inch" || type === "feet") {
        if (name === "height") {
          this.height.cm = this.convertFeetAndInchesToCm(
            this.height.feet,
            this.height.inch
          );
        }

        if (name === "width") {
          this.width[0].cm = this.convertFeetAndInchesToCm(
            this.width[0].feet,
            this.width[0].inch
          );
        }
      }

      if (type === "cm") {
        if (name === "height") {
          const { feet, inches } = this.convertCmToFeetAndInches(this.height.cm);
          this.height.feet = feet;
          this.height.inch = inches;
        }

        if (name === "width") {
          const { feet, inches } = this.convertCmToFeetAndInches(this.width[0].cm);
          this.width[0].feet = feet;
          this.width[0].inch = inches;
        }
      }

      this.$nextTick(() => {
        if (this.newImageURL) {
          this.resetCropBox();
          this.initializeCropBox();
        }
      });
    },

    convertFeetAndInchesToCm(feet, inches) {
      const safeFeet = parseFloat(feet) || 0;
      const safeInches = parseFloat(inches) || 0;
      const totalInches = safeFeet * 12 + safeInches;

      return (totalInches * 2.54).toFixed(2);
    },

    convertCmToFeetAndInches(cm) {
      const safeCm = parseFloat(cm) || 0;
      const totalInches = safeCm / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = (totalInches % 12).toFixed(2);

      return { feet, inches };
    },

    handleImageFileChange(event) {
      const file = event.target.files[0];

      if (!file) return;

      const validImageTypes = ["image/jpeg", "image/png", "image/gif"];

      if (!validImageTypes.includes(file.type)) {
        alert("Only image files — JPG, PNG, or GIF — are allowed.");
        event.target.value = "";
        return;
      }

      if (file.size > 20 * 1024 * 1024) {
        alert(
          "File size must be less than 20MB. If larger, please email hello@wallsneedlove.com."
        );
        event.target.value = "";
        return;
      }

      this.newImage = file;
      this.newImageURL = undefined;
      this.croppedImageURL = null;
      this.cropboxData = {};
      this._cropBoxInitialized = false;

      const reader = new FileReader();

      reader.onload = () => {
        this.newImageURL = reader.result;

        this.$nextTick(() => {
          this.initializeCropBox();
        });
      };

      reader.readAsDataURL(file);
    },

    resetCropBox() {
      const box = document.querySelector("[data-custom-mural-crop-box]");

      if (!box) return;

      box.style.width = "";
      box.style.height = "";
      box.style.left = "";
      box.style.top = "";

      this.cropboxData = {};
    },

    initializeCropBox() {
      if (!this.newImageURL) return;

      const image = document.querySelector("[data-custom-mural-crop-image]");
      const box = document.querySelector("[data-custom-mural-crop-box]");

      if (!image || !box) return;

      const setDefaultCropBox = () => {
        const imageRect = image.getBoundingClientRect();

        if (!imageRect.width || !imageRect.height) return;

        const wallRatio = this.getWallAspectRatio();

        let cropWidth = imageRect.width * 0.75;
        let cropHeight = cropWidth / wallRatio;

        if (cropHeight > imageRect.height * 0.75) {
          cropHeight = imageRect.height * 0.75;
          cropWidth = cropHeight * wallRatio;
        }

        if (cropWidth > imageRect.width) {
          cropWidth = imageRect.width;
          cropHeight = cropWidth / wallRatio;
        }

        if (cropHeight > imageRect.height) {
          cropHeight = imageRect.height;
          cropWidth = cropHeight * wallRatio;
        }

        const cropLeft = (imageRect.width - cropWidth) / 2;
        const cropTop = (imageRect.height - cropHeight) / 2;

        box.style.width = `${cropWidth}px`;
        box.style.height = `${cropHeight}px`;
        box.style.left = `${cropLeft}px`;
        box.style.top = `${cropTop}px`;

        this.updateCropBoxData(image, box);
      };

      if (image.complete && image.naturalWidth) {
        setDefaultCropBox();
      } else {
        image.onload = setDefaultCropBox;
      }

      if (!this._cropBoxInitialized) {
        this.enableCropBoxDragging(box, image);
        this.enableCropBoxResizing(box, image);
        this._cropBoxInitialized = true;
      }
    },

    getWallAspectRatio() {
      const heightInFeet =
        Number(this.height.feet || 0) + Number((this.height.inch || 0) / 12);

      const widthInFeet =
        Number(this.width[0].feet || 0) + Number((this.width[0].inch || 0) / 12);

      if (heightInFeet > 0 && widthInFeet > 0) {
        return widthInFeet / heightInFeet;
      }

      return 1;
    },

    updateCropBoxData(image, box) {
      const imageRect = image.getBoundingClientRect();
      const boxRect = box.getBoundingClientRect();

      const x = boxRect.left - imageRect.left;
      const y = boxRect.top - imageRect.top;

      this.cropboxData = {
        x,
        y,
        width: boxRect.width,
        height: boxRect.height,
        displayImageWidth: imageRect.width,
        displayImageHeight: imageRect.height,
        naturalImageWidth: image.naturalWidth,
        naturalImageHeight: image.naturalHeight,
        flipped: this.flipped,
      };
    },

    enableCropBoxDragging(box, image) {
      let isDragging = false;
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      let startTop = 0;

      const getClientPosition = (event) => {
        const point = event.touches ? event.touches[0] : event;

        return {
          x: point.clientX,
          y: point.clientY,
        };
      };

      const onMove = (event) => {
        if (!isDragging) return;

        event.preventDefault();

        const position = getClientPosition(event);
        const imageRect = image.getBoundingClientRect();
        const boxRect = box.getBoundingClientRect();

        let newLeft = startLeft + position.x - startX;
        let newTop = startTop + position.y - startY;

        newLeft = Math.max(0, Math.min(newLeft, imageRect.width - boxRect.width));
        newTop = Math.max(0, Math.min(newTop, imageRect.height - boxRect.height));

        box.style.left = `${newLeft}px`;
        box.style.top = `${newTop}px`;

        this.updateCropBoxData(image, box);
      };

      const onEnd = () => {
        isDragging = false;

        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onEnd);
        document.removeEventListener("touchmove", onMove);
        document.removeEventListener("touchend", onEnd);
      };

      const onStart = (event) => {
        if (event.target.dataset.cropResizeHandle !== undefined) return;

        event.preventDefault();

        const position = getClientPosition(event);

        isDragging = true;
        startX = position.x;
        startY = position.y;
        startLeft = parseFloat(box.style.left || 0);
        startTop = parseFloat(box.style.top || 0);

        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onEnd);
        document.addEventListener("touchmove", onMove, { passive: false });
        document.addEventListener("touchend", onEnd);
      };

      box.addEventListener("mousedown", onStart);
      box.addEventListener("touchstart", onStart, { passive: false });
    },

    enableCropBoxResizing(box, image) {
      const handle = box.querySelector("[data-crop-resize-handle]");

      if (!handle) return;

      let isResizing = false;
      let startX = 0;
      let startY = 0;
      let startWidth = 0;
      let startHeight = 0;
      let startLeft = 0;
      let startTop = 0;

      const getClientPosition = (event) => {
        const point = event.touches ? event.touches[0] : event;

        return {
          x: point.clientX,
          y: point.clientY,
        };
      };

      const onMove = (event) => {
        if (!isResizing) return;

        event.preventDefault();

        const position = getClientPosition(event);
        const imageRect = image.getBoundingClientRect();
        const wallRatio = this.getWallAspectRatio();

        const deltaX = position.x - startX;
        const deltaY = position.y - startY;

        let requestedWidth;
        let requestedHeight;

        if (Math.abs(deltaX) >= Math.abs(deltaY)) {
          requestedWidth = startWidth + deltaX;
          requestedHeight = requestedWidth / wallRatio;
        } else {
          requestedHeight = startHeight + deltaY;
          requestedWidth = requestedHeight * wallRatio;
        }

        const minWidth = 80;
        const minHeight = minWidth / wallRatio;

        const maxWidthByImage = imageRect.width - startLeft;
        const maxHeightByImage = imageRect.height - startTop;

        let maxWidth = maxWidthByImage;
        let maxHeight = maxWidth / wallRatio;

        if (maxHeight > maxHeightByImage) {
          maxHeight = maxHeightByImage;
          maxWidth = maxHeight * wallRatio;
        }

        let newWidth = requestedWidth;
        let newHeight = requestedHeight;

        if (newWidth < minWidth) {
          newWidth = minWidth;
          newHeight = newWidth / wallRatio;
        }

        if (newHeight < minHeight) {
          newHeight = minHeight;
          newWidth = newHeight * wallRatio;
        }

        if (newWidth > maxWidth) {
          newWidth = maxWidth;
          newHeight = newWidth / wallRatio;
        }

        if (newHeight > maxHeight) {
          newHeight = maxHeight;
          newWidth = newHeight * wallRatio;
        }

        box.style.width = `${newWidth}px`;
        box.style.height = `${newHeight}px`;

        this.updateCropBoxData(image, box);
      };

      const onEnd = () => {
        isResizing = false;

        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onEnd);
        document.removeEventListener("touchmove", onMove);
        document.removeEventListener("touchend", onEnd);
      };

      const onStart = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const position = getClientPosition(event);
        const imageRect = image.getBoundingClientRect();
        const boxRect = box.getBoundingClientRect();

        isResizing = true;

        startX = position.x;
        startY = position.y;

        startWidth = boxRect.width;
        startHeight = boxRect.height;

        startLeft = boxRect.left - imageRect.left;
        startTop = boxRect.top - imageRect.top;

        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onEnd);
        document.addEventListener("touchmove", onMove, { passive: false });
        document.addEventListener("touchend", onEnd);
      };

      handle.addEventListener("mousedown", onStart);
      handle.addEventListener("touchstart", onStart, { passive: false });
    },

    calculatePrice() {
      if (!this.variant?.price) return 0;

      if (
        (!this.height.feet && !this.height.inch) ||
        (!this.width[0].feet && !this.width[0].inch)
      ) {
        return 0;
      }

      const heightInFeet =
        Number(this.height.feet || 0) + Number((this.height.inch || 0) / 12);

      const widthInFeet =
        Number(this.width[0].feet || 0) + Number((this.width[0].inch || 0) / 12);

      const squareFeet = Math.ceil(heightInFeet * widthInFeet);

      if (!squareFeet || squareFeet <= 0) return 0;

      this.quantity = squareFeet;

      const basePrice = Number(this.variant.price) / 100;
      const totalPrice = basePrice * squareFeet;

      return totalPrice.toFixed(2);
    },

    async get() {
      return new Promise((resolve) => {
        if (!this.newImageURL) {
          console.error("No uploaded image URL found.");
          resolve();
          return;
        }

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const image = new Image();
        image.src = this.newImageURL;

        image.onload = () => {
          const crop = this.cropboxData;

          if (
            !crop.width ||
            !crop.height ||
            !crop.displayImageWidth ||
            !crop.displayImageHeight
          ) {
            console.warn("No valid crop box data found. Using full image.");
            this.croppedImageURL = this.newImageURL;
            resolve();
            return;
          }

          const scaleX = image.naturalWidth / crop.displayImageWidth;
          const scaleY = image.naturalHeight / crop.displayImageHeight;

          const sourceX = crop.x * scaleX;
          const sourceY = crop.y * scaleY;
          const sourceWidth = crop.width * scaleX;
          const sourceHeight = crop.height * scaleY;

          canvas.width = Math.round(sourceWidth);
          canvas.height = Math.round(sourceHeight);

          if (this.flipped) {
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);
          }

          ctx.drawImage(
            image,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            0,
            0,
            canvas.width,
            canvas.height
          );

          this.croppedImageURL = canvas.toDataURL("image/png");
          resolve();
        };

        image.onerror = () => {
          console.error("Failed to load image:", this.newImageURL);
          resolve();
        };
      });
    },

    async generateCropPreviewImage() {
      return new Promise((resolve) => {
        if (!this.newImageURL) {
          resolve(null);
          return;
        }

        const image = new Image();
        image.src = this.newImageURL;

        image.onload = () => {
          const crop = this.cropboxData;

          if (
            !crop.width ||
            !crop.height ||
            !crop.displayImageWidth ||
            !crop.displayImageHeight
          ) {
            resolve(this.newImageURL);
            return;
          }

          const maxPreviewWidth = 1600;
          const scale = Math.min(1, maxPreviewWidth / image.naturalWidth);

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = Math.round(image.naturalWidth * scale);
          canvas.height = Math.round(image.naturalHeight * scale);

          ctx.save();

          if (this.flipped) {
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);
          }

          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

          ctx.restore();

          const cropScaleX = image.naturalWidth / crop.displayImageWidth;
          const cropScaleY = image.naturalHeight / crop.displayImageHeight;

          let cropX = crop.x * cropScaleX * scale;
          const cropY = crop.y * cropScaleY * scale;
          const cropWidth = crop.width * cropScaleX * scale;
          const cropHeight = crop.height * cropScaleY * scale;

          if (this.flipped) {
            cropX = canvas.width - cropX - cropWidth;
          }

          ctx.save();

          ctx.fillStyle = "rgba(0, 0, 0, 0.45)";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          ctx.clearRect(cropX, cropY, cropWidth, cropHeight);

          if (this.flipped) {
            ctx.save();
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);

            const sourceX = crop.x * cropScaleX;
            const sourceY = crop.y * cropScaleY;
            const sourceWidth = crop.width * cropScaleX;
            const sourceHeight = crop.height * cropScaleY;

            const flippedDestinationX = canvas.width - cropX - cropWidth;

            ctx.drawImage(
              image,
              sourceX,
              sourceY,
              sourceWidth,
              sourceHeight,
              flippedDestinationX,
              cropY,
              cropWidth,
              cropHeight
            );

            ctx.restore();
          } else {
            ctx.drawImage(
              image,
              crop.x * cropScaleX,
              crop.y * cropScaleY,
              crop.width * cropScaleX,
              crop.height * cropScaleY,
              cropX,
              cropY,
              cropWidth,
              cropHeight
            );
          }

          ctx.strokeStyle = "#ee2266";
          ctx.lineWidth = Math.max(4, Math.round(canvas.width * 0.004));
          ctx.strokeRect(cropX, cropY, cropWidth, cropHeight);

          const labelText = "Selected Crop Area";
          const fontSize = Math.max(24, Math.round(canvas.width * 0.025));

          ctx.font = `bold ${fontSize}px Arial, sans-serif`;
          ctx.textBaseline = "top";

          const labelPadding = Math.round(fontSize * 0.45);
          const labelWidth = ctx.measureText(labelText).width + labelPadding * 2;
          const labelHeight = fontSize + labelPadding * 1.5;

          let labelX = cropX;
          let labelY = cropY - labelHeight - 8;

          if (labelY < 0) {
            labelY = cropY + 8;
          }

          if (labelX + labelWidth > canvas.width) {
            labelX = canvas.width - labelWidth - 8;
          }

          if (labelX < 0) {
            labelX = 8;
          }

          ctx.fillStyle = "#ee2266";
          ctx.fillRect(labelX, labelY, labelWidth, labelHeight);

          ctx.fillStyle = "#ffffff";
          ctx.fillText(
            labelText,
            labelX + labelPadding,
            labelY + labelPadding * 0.65
          );

          ctx.restore();

          resolve(canvas.toDataURL("image/png"));
        };

        image.onerror = () => {
          console.error("Failed to generate crop preview image.");
          resolve(null);
        };
      });
    },

    async base64ToBlob(base64, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(base64.split(",")[1]);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: contentType });
    },

    async addToCart() {
      if (!this.newImage || !this.variant?.id) {
        alert("Please select an image and paper type.");
        return;
      }

      if (!this.imageUsagePermission) {
        alert(
          "Please confirm that you own the rights or have been granted permission to use the image."
        );
        return;
      }

      try {
        await this.get();

        const cropPreviewImageURL = await this.generateCropPreviewImage();

        const formData = new FormData();

        formData.append("id", this.variant.id);
        formData.append("quantity", this.quantity);

        formData.append(
          "properties[Height]",
          `${this.height.feet || 0}ft ${this.height.inch || 0}in`
        );

        formData.append(
          "properties[Width]",
          `${this.width[0].feet || 0}ft ${this.width[0].inch || 0}in`
        );

        formData.append("properties[Instructions]", this.instructions || "");

        formData.append(
          "properties[Flip Image]",
          this.flipped ? "Yes" : "No"
        );

        formData.append(
          "properties[Crop Box X]",
          this.cropboxData?.x ? String(Math.round(this.cropboxData.x)) : "0"
        );

        formData.append(
          "properties[Crop Box Y]",
          this.cropboxData?.y ? String(Math.round(this.cropboxData.y)) : "0"
        );

        formData.append(
          "properties[Crop Box Width]",
          this.cropboxData?.width ? String(Math.round(this.cropboxData.width)) : "0"
        );

        formData.append(
          "properties[Crop Box Height]",
          this.cropboxData?.height ? String(Math.round(this.cropboxData.height)) : "0"
        );

        formData.append(
          "properties[original_custom_mural]",
          this.newImage,
          this.newImage.name
        );

        const croppedImageBlob = await this.base64ToBlob(
          this.croppedImageURL || this.newImageURL,
          "image/png"
        );

        formData.append(
          "properties[cropped_custom_mural]",
          croppedImageBlob,
          `cropped-${this.newImage.name.replace(/\.[^/.]+$/, "")}.png`
        );

        if (cropPreviewImageURL) {
          const cropPreviewBlob = await this.base64ToBlob(
            cropPreviewImageURL,
            "image/png"
          );

          formData.append(
            "properties[crop_preview_custom_mural]",
            cropPreviewBlob,
            `crop-preview-${this.newImage.name.replace(/\.[^/.]+$/, "")}.png`
          );
        }

        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          throw new Error("Failed to add to cart.");
        }

        window.location.href = "/cart";
      } catch (error) {
        console.log("Error adding to cart:", error);
        alert("Failed to add item to cart. Please try again.");
      }
    },
  };
}